export const IS_IDENTIFIED = ['data', 'isIdentified'];